import { useState, type FormEvent } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Hero() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState('');

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/category?q=${encodeURIComponent(q)}` : '/category');
  };

  return (
    <section className="relative flex min-h-[620px] w-full items-center justify-center overflow-hidden md:min-h-[680px]">
      <img
        src="https://readdy.ai/api/search-image?query=Stylized%20illustrated%20Korean%20city%20skyline%20at%20twilight%20with%20glowing%20neon%20signs%2C%20books%20and%20comic%20pages%20floating%20in%20the%20air%2C%20warm%20coral%20orange%20and%20gold%20light%20gradients%2C%20cinematic%20dreamy%20atmosphere%2C%20high%20detail%20digital%20artwork%20for%20a%20web%20hero%20background%2C%20wide%20landscape%20composition&width=1600&height=900&seq=hero-kcomic-main&orientation=landscape"
        alt="韩漫星球 - 海量韩国漫画畅读背景图"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/90 px-4 py-1.5 text-sm font-medium text-background-50">
          <i className="ri-fire-line"></i> 每日更新 · 海量韩漫
        </span>
        <h1 className="mt-6 font-heading text-3xl leading-snug text-background-50 md:text-5xl md:leading-snug">
          一站畅读 · 每一部都值得看的韩国漫画
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-sm leading-7 text-background-100 md:text-base md:leading-8">
          爱情、奇幻、动作、校园、悬疑，全部分类一网打尽。高清画质、同步更新，帮你快速找到想看的每一部佳作。
        </p>

        <form
          onSubmit={onSubmit}
          role="search"
          className="mx-auto mt-8 flex max-w-xl flex-col gap-2 sm:flex-row sm:items-center sm:gap-0 sm:rounded-full sm:bg-background-50/95 sm:p-1.5 sm:backdrop-blur"
        >
          <label htmlFor="search-input" className="sr-only">搜索漫画</label>
          <input
            id="search-input"
            type="text"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索你喜欢的漫画名称或作者…"
            className="flex-1 rounded-full bg-background-50/95 px-5 py-3 text-sm text-foreground-800 outline-none sm:bg-transparent sm:py-2.5"
          />
          <button
            type="submit"
            className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:mt-0 sm:py-2.5 whitespace-nowrap"
          >
            <i className="ri-search-line"></i> 搜索
          </button>
        </form>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          {categories.map((c) => (
            <Link
              key={c.key}
              to={`/category?cat=${c.key}`}
              className="inline-flex items-center gap-1.5 rounded-full border border-background-50/25 bg-background-950/30 px-3.5 py-1.5 text-xs text-background-50 backdrop-blur transition-colors hover:bg-background-50/15 whitespace-nowrap"
            >
              <i className={c.icon}></i> {c.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}